class WeChatAuth {
  constructor(config) {
    const defaultConfig = {
      appid: '',
      responseType: 'code',
      scope: 'snsapi_userinfo',
      getCodeCallback: () => { }
    }
    this.config = Object.assign(defaultConfig, config)
  }

  openAuthPage(redirectUri = window.location.href) {
    redirectUri = encodeURIComponent(redirectUri)
    this.removeAuthCode()
    const authPageBaseUri = 'https://open.weixin.qq.com/connect/oauth2/authorize'
    const authParams = `?appid=wx83d351356eb8c592&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_userinfo#wechat_redirect`
    window.location.replace(authPageBaseUri + authParams)
  }

  setAuthCode(code) {
    if (!code) return false
    window.sessionStorage.setItem('auth_code', code)
    return true
  }

  getAuthCode() {
    const codeValue = window.sessionStorage.getItem('auth_code')
    if (!codeValue) return ''
    return codeValue
  }

  removeAuthCode() {
    window.sessionStorage.removeItem('auth_code')
  }

  removeUrlCodeQuery() {
    const location = window.location
    let search = location.search
    if (search) {
      search = search.substr(1)
    }
    let href = location.origin
    const pathName = location.pathname
    if (pathName) {
      href += pathName
    }
    const searchArr = search.split('&').filter(item => {
      if (item.indexOf('code=') !== -1) {
        return false
      }
      if (item.indexOf('state=') !== -1) {
        return false
      }
      if (item.indexOf('appid=') !== -1) {
        return false
      }
      return true
    })
    if (searchArr.length > 0) {
      href += '?' + searchArr.join('&')
    }
    const hash = location.hash
    if (hash) {
      href += hash
    }
    window.location.replace(href)
  }
}
export default WeChatAuth
